if(!customElements.get('multimedia-collage')) {
    class MultimediaCollage extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.template = this.querySelector('template');
            this.container = this.querySelector(".multimedia-collage-container");

            this.loadBlocks();
        }

        loadBlocks(){
            const template = this.template.content.cloneNode(true);
            const blocks = template.querySelectorAll(".multimedia-collage__block");

            if(blocks.length === 0) return;

            blocks.forEach((block, index) => {
                block.setAttribute('data-index', index + 1);
            });

            const firstBlock = blocks[0] ?? null;
            this.container.appendChild(firstBlock);

            if(blocks.length > 1){
                const restBlocks = Array.from(blocks).slice(1, blocks.length);
                if(restBlocks.length > 0){
                    const restBlocksWrapper = document.createElement('div');
                    restBlocksWrapper.className = 'multimedia-collage__block-group overflow-hidden w-full flex flex-wrap';

                    restBlocks.forEach((block, index) => {
                       restBlocksWrapper.appendChild(block);
                    });

                    this.container.appendChild(restBlocksWrapper);
                }
            }
        }
    }

    customElements.define('multimedia-collage', MultimediaCollage);
}